import { Dialog, DialogContent, IconButton } from '@mui/material';
import React, { FC } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { InvestigationTransaction } from '../TransactionsComponentsVariants/TransactionsTable/transactions.types';
import { TransactionsDetails } from '../TransactionsComponentsVariants/Common/TransactionsDetails';

interface TransactionDetailsDialogProps {
	open: boolean;
	transactionDetails: InvestigationTransaction;
	handleClose: () => void;
}

export const TransactionDetailsDialog: FC<TransactionDetailsDialogProps> = ({
	open,
	transactionDetails,
	handleClose,
}) => {
	return (
		<Dialog keepMounted={false} open={open}>
			<IconButton
				aria-label="closeTransactionDetailsButton"
				onClick={handleClose}
				sx={{
					position: 'absolute',
					right: 8,
					top: 8,
				}}>
				<CloseIcon />
			</IconButton>
			<DialogTitle />
			<DialogContent>
				<TransactionsDetails transactionDetails={transactionDetails} />
			</DialogContent>
		</Dialog>
	);
};
